import { RESET_ALL_STATES } from "../actions/actions";

import {
    RESEND_STATUS_REQUEST,
    RESEND_STATUS_SUCCESS,
    RESEND_STATUS_FAILURE,
} from "../actions/actionTypes";

const initialState = {
  isLoading: false,
  error: null,
  data: null,
};

const smsResendReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESEND_STATUS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case RESEND_STATUS_SUCCESS:
      return { ...state, isLoading: false, data: action.payload };
    case RESEND_STATUS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case RESET_ALL_STATES:
      return initialState;
    default:
      return state;
  }
};

export default smsResendReducer;
